var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"list-range",attrs:{"role":"status"}},[(_vm.loading)?_c('span',[_vm._v("件数を確認中…")]):(_vm.error)?_c('span',[_vm._v("件数を取得できませんでした。")]):(_vm.total !== null)?_c('span',[_vm._v(_vm._s(_vm.label)+"全"+_vm._s(_vm.number(_vm.total))+"件中 "+_vm._s(_vm.number(_vm.start))+"〜"+_vm._s(_vm.number(_vm.end))+"件を表示")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }